import type { XYPosition } from '../core';

/** The gesture surface that holds pane and viewport (`.cm-renderer`). */
export const RENDERER_SELECTOR = '.cm-renderer';

/** Mouse position relative to `element`'s top-left corner (renderer coordinates). */
export const rendererPoint = (element: Element, { clientX, clientY }: { clientX: number; clientY: number }): XYPosition => {
  const rect = element.getBoundingClientRect();
  return { x: clientX - rect.left, y: clientY - rect.top };
};
